import React from 'react';
import clsx from 'clsx';

/**
 * LoungeBackground - Cosmic Afrofuturist Background Wrapper
 * 
 * Creates the immersive neon-glass environment with:
 * - Deep cosmic indigo base
 * - Radial gradient washes (pink, teal, amber)
 * - Subtle particle texture
 * - Vignette effect
 */
export function LoungeBackground({ children }) {
  return (
    <div
      className="min-h-screen relative overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0F1730 0%, #1A1F3A 50%, #0E1228 100%)',
      }}
    >
      {/* Radial gradient washes */}
      <div
        className="absolute inset-0 opacity-60"
        style={{
          background: `
            radial-gradient(circle at 20% 30%, rgba(236, 72, 153, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(45, 212, 191, 0.12) 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, rgba(251, 191, 36, 0.08) 0%, transparent 60%)
          `,
        }}
      />
      
      {/* Subtle particle texture */}
      <div
        className="absolute inset-0 opacity-[0.18] mix-blend-soft-light"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      />
      
      {/* Vignette effect */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(circle at center, transparent 0%, rgba(15, 23, 48, 0.4) 100%)',
        }}
      />
      
      {/* Content layer */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}
